/** @format */

import React, { FC, useState } from 'react'
import { _$, Card, Tab, Tabs } from '@king-design/react'
import styled from 'styled-components'
import { MonitorCrumb } from 'src/components'
import useNavRegion from 'src/hooks/useNavRegion'
import PrometheusAlarmPolicy from 'src/containers/PrometheusMonitor/Alarm/Policy'
import PrometheusAlarming from 'src/containers/PrometheusMonitor/Alarm/Alarming'
import PrometheusAlarmNotificRecord from 'src/containers/PrometheusMonitor/Alarm/NotificRecord'
import PrometheusAlarmTemplate from 'src/containers/PrometheusMonitor/Alarm/Template'
import PrometheusAlarmDenoise from 'src/containers/PrometheusMonitor/Alarm/Denoise'
import { useHistory, useLocation } from 'react-router'
import { getPromethuesInstance } from 'src/api/ApiPromethuesInstance'
import { useAsync } from 'react-use'
function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export interface PrometheusAlarmTabProps {
  className?: string
  tab: string
  region: string
  instances: { id: string; name: string }[]
}

const PrometheusAlarm: FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const initialTab = query.get('tab') || 'policy'
  const [tab, setTab] = useState<string>(initialTab)
  // 控制台region
  const region = useNavRegion()

  // 账户下实例
  const { value: instances } = useAsync(async () => {
    if (region) {
      const result = await getPromethuesInstance({
        SearchRegion: region
      })
      return (
        result?.InstancesSet?.map(item => {
          return { name: item.InstanceName, id: item.ControllerID }
        }) || []
      )
    }
  }, [region])

  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('Prometheus监控') }, { title: _$('告警管理') }]} />
      <Tabs
        type="card"
        value={tab}
        onChangeValue={tab => {
          history.push(`/monitor/prometheusmonitor/alarm?tab=${tab}`)
          setTab(tab)
        }}
      >
        <Tab value="policy">{_$('告警策略')}</Tab>
        <Tab value="alarming">{_$('告警中')}</Tab>
        <Tab value="notific">{_$('通知记录')}</Tab>
        <Tab value="template">{_$('告警模板')}</Tab>
        <Tab value="denoise">{_$('告警降噪')}</Tab>
      </Tabs>
      <Card>
        <div className="tab_content">
          {tab === 'policy' ? (
            <PrometheusAlarmPolicy tab={tab} region={region} instances={instances} />
          ) : null}
          {tab === 'alarming' ? (
            <PrometheusAlarming tab={tab} region={region} instances={instances} />
          ) : null}
          {tab === 'notific' ? (
            <PrometheusAlarmNotificRecord tab={tab} region={region} instances={instances} />
          ) : null}
          {tab === 'template' ? (
            <PrometheusAlarmTemplate tab={tab} region={region} instances={instances} />
          ) : null}
          {tab === 'denoise' ? (
            <PrometheusAlarmDenoise tab={tab} region={region} instances={instances} />
          ) : null}
        </div>
      </Card>
    </div>
  )
}

export default styled(PrometheusAlarm)`
  padding: 0 16px;
  .k-tabs {
    border-radius: 4px 4px 0 0;
  }
  .k-card {
    border-radius: 0 0 4px 4px;
  }
  .header {
    padding-bottom: 16px;
    .k-btn {
      margin-right: 4px;
    }
  }
  .k-table {
    p {
      margin: 0;
    }
    .text_container {
      .read_more {
        white-space: nowrap; /* 防止 <a> 换行 */
        flex-shrink: 0; /* 防止 <a> 被压缩 */
      }
    }
    .table_text {
      color: #999;
    }
  }
  .k-pagination {
    margin-top: 16px;
    text-align: center;
  }
`
